import './contactPopupModel.css';
import Datepicker from '../../../lib/Datepicker/Datepicker';
import InputWidget from '../../../lib/InputWidget/InputWidget';
import {getServiceRequestDetailsAction} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import {postAPICall} from '../../../services/apiCallsHandler';
import 'flatpickr/dist/themes/light.css';
import {getLocalDatePickerFile} from '../../../utils/util';

import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalTitle,
  TextField,
  Typography,
  useToastProvider,
  CircularProgress,
  Select,
  Option,
} from '@deere/fuel-react';
import moment from 'moment';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {Navigate} from 'react-router-dom';

const ContactPopupModal = ({
  visible,
  setVisible,
  contractNumber,
  countryCode,
  userDetails,
  selectedOrg,
}) => {
  const {t} = useTranslation();

  const [date, setDate] = React.useState(null);
  const [time, setTime] = React.useState(null);
  const [submitDisabled, setSubmitDisabled] = React.useState(true);
  const [reason, setReason] = React.useState(null);
  const [isErrorRedirect, setIsErrorRedirect] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [alternateNumber, setAlternateNumber] = React.useState('');

  const {enqueueToast} = useToastProvider();

  const handleCancel = () => {
    setVisible(false);
    setDate(null);
    setTime(null);
    setAlternateNumber('');
  };

  const onChangeHandler = (value) => {
    if (value.length <= 9) {
      const cleanedValue = value.replaceAll(/\D/g, '');
      setAlternateNumber(cleanedValue);
      if (value.length !== 9 && value !== '') {
        setSubmitDisabled(true);
      } else {
        setSubmitDisabled(false);
      }
    }
  };

  const submitHandler = () => {
    let payload = {
      contractNumber:
        contractNumber.contracts &&
        contractNumber.contracts.length > 0 &&
        contractNumber.contracts[0].contractNumber,
      requestDate: date && moment(date[0]).format('YYYY/MM/DD'),
      requestReason: reason,
      timespan: time,
      alternateNumber: alternateNumber,
      requestType: 'Callback',
      countryCode: countryCode,
      userEmail: userDetails.email,
    };
    if (selectedOrg) {
      payload.party = selectedOrg;
    }
    setSubmitDisabled(true);
    setLoader(true);
    postAPICall(
      'serviceRequest',
      payload,
      {
        errorTag: 'CONTACT_CALLBACK_MODAL',
      },
      redirectErrorCallBack
    ).then((res) => {
      setLoader(false);
      setSubmitDisabled(false);
      setVisible(false);

      if (res.status == 200) {
        appStore.dispatch(getServiceRequestDetailsAction(null));
        setDate(null);
        setAlternateNumber('');
        setTime(null);
        setReason(null);
        enqueueToast({
          variant: 'success',
          title: t('SERVICE_REQUEST_SUCCESS'),
          isCloseable: true,
        });
      }
    });
  };

  const reasonHandler = (e) => {
    setSubmitDisabled(false);
    setReason(e.target.value);
  };

  const redirectErrorCallBack = () => {
    setIsErrorRedirect(true);
  };
  const timeArray = [
    '09:00 AM - 09:30 AM',
    '09:30 AM - 10:00 AM',
    '10:00 AM - 10:30 AM',
    '10:30 AM - 11:00 AM',
    '11:00 AM - 11:30 AM',
    '11:30 AM - 12:00 PM',
    '12:00 PM - 12:30 PM',
    '12:30 PM - 01:00 PM',
    '01:00 PM - 01:30 PM',
    '01:30 PM - 02:00 PM',
    '02:00 PM - 02:30 PM',
    '02:30 PM - 03:00 PM',
    '03:00 PM - 03:30 PM',
    '03:30 PM - 04:00 PM',
  ];

  const datePickerOptions = {
    minDate: new Date(new Date().setDate(new Date().getDate() + 1)),
    disable: [
      function (date) {
        return date.getDay() === 0 || date.getDay() === 6;
      },
    ],
    dateFormat: 'd M Y',
    locale: getLocalDatePickerFile(),
  };

  return (
    <>
      {isErrorRedirect && <Navigate to="/oops" />}

      <Modal
        open={visible}
        onClose={handleCancel}
        aria-labelledby="alert-Modal-title-contact"
        aria-describedby="alert-Modal-description"
      >
        <ModalTitle id="alert-Modal-title-contact">
          {t('CONTACT_MODAL_TITLE')}
        </ModalTitle>
        <ModalContent id="contact-popup-modal-content">
          <TextField
            label={t('CALLBACK_REASON')}
            type="text"
            placeholder={t('CALLBACK_REASON_PLACEHOLDER')}
            multiline
            minRows={3}
            required={true}
            size="small"
            onChange={(e) => {
              reasonHandler(e);
            }}
          />
          <div id="contact-datepicker">
            <Typography gutterBottom variant="h5" required={true}>
              {t('CALLBACK_DATE')}{' '}
              <span className="datepicker-asterisk">*</span>
            </Typography>
            <Datepicker
              placeholder="DD MMM YYYY"
              isRequired={true}
              setDate={(e) => {
                setDate(e);
              }}
              value={date}
              options={datePickerOptions}
            />
          </div>
          <div className="contact-timepicker">
            <Typography gutterBottom variant="h5" required={true}>
              {t('CALLBACK_TIME')}{' '}
              <span className="datepicker-asterisk">*</span>
            </Typography>

            <Select
              fullWidth={true}
              id="contact-popup-time"
              defaultValue={time}
              size="small"
              data-testid="contact-popup-time"
              onChange={(e) => {
                setTime(e.target.value);
              }}
              displayEmpty
              disabled={!date}
              placeholder={t('REASON_HELPER_TEXT')}
            >
              {timeArray.map((el, index) => {
                return (
                  <Option
                    key={el}
                    value={el}
                    id={el}
                    className="time-picker-options"
                  >
                    {el}
                  </Option>
                );
              })}
            </Select>
          </div>

          <div>
            <InputWidget
              label={t('ALT_PHONE_NUMBER')}
              type="text"
              data-testid="alternative-phone-number"
              required={false}
              value={alternateNumber}
              setValue={onChangeHandler}
              customError={true}
              error={alternateNumber.length == 9 || alternateNumber == ''}
              helperText={t('ALTERNATE_NUMBER_FORMAT')}
            />
          </div>

          <Typography variant="h6" required={true} id="callback-note">
            {t('CALLBACK_NOTE')}
          </Typography>
        </ModalContent>
        <ModalActions id="contact-popup-action">
          <Button id="cancelButton" onClick={handleCancel} variant="secondary">
            {t('CANCEL')}
          </Button>

          <Button
            id="primaryBtn"
            onClick={submitHandler}
            variant="primary"
            data-testid="primary-popup-btn"
            disabled={
              date === null ||
              reason === null ||
              time === null ||
              submitDisabled
            }
            startIcon={
              loader && (
                <CircularProgress size="small" style={{color: '#000'}} />
              )
            }
          >
            {t('SUBMIT')}
          </Button>
        </ModalActions>
      </Modal>
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    contractNumber: state.appStates.contractNumbers,
    countryCode: state.appStates.allContracts?.countryCode,
    userDetails: state.appStates.userDetailsInfo,
    selectedOrg: state.appStates.selectedOrg,
  };
};

export default connect(mapStateToProps)(ContactPopupModal);
